import React from "react";

function Faq() {
  return (
    <>
      <div className="faq" id="faq">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12 text-center wow fadeInUp"
              data-wow-duration="0.4s"
              data-wow-delay="0.4s"
            >
              <div className="section-head">
                <h2 className="title">
                  FAQs: Donations with crypto currencies
                </h2>
              </div>
            </div>
          </div>
          <div className="row align-items-center justify-content-between">
            <div className="col-xl-8">
              <div className="faq-box">
                <div className="accordion" id="accordionExample">
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-duration="0.4s"
                    data-wow-delay="0.4s"
                  >
                    <h2 className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-expanded="false"
                        aria-controls="collapseOne"
                      >
                        How does a donation with a cryptocurrency work?
                      </button>
                    </h2>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Ea commodi eius nisi fugiat eligendi neque repellendus
                        vero, aliquam temporibus, dicta optio eveniet saepe.
                        Beatae hic fugiat qui possimus doloribus? Ratione,
                        molestiae magnam.
                      </div>
                    </div>
                  </div>
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-duration="0.4s"
                    data-wow-delay="0.4s"
                  >
                    <h2 className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        How are we handling security of our wallets?
                      </button>
                    </h2>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingTwo"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Ea commodi eius nisi fugiat eligendi neque repellendus
                        vero, aliquam temporibus, dicta optio eveniet saepe.
                        Beatae hic fugiat qui possimus doloribus? Ratione,
                        molestiae magnam.
                      </div>
                    </div>
                  </div>
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-duration="0.4s"
                    data-wow-delay="0.4s"
                  >
                    <h2 className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        How do donated coins get exchanged back to euro?
                      </button>
                    </h2>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingThree"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Ea commodi eius nisi fugiat eligendi neque repellendus
                        vero, aliquam temporibus, dicta optio eveniet saepe.
                        Beatae hic fugiat qui possimus doloribus? Ratione,
                        molestiae magnam.
                      </div>
                    </div>
                  </div>
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-duration="0.4s"
                    data-wow-delay="0.4s"
                  >
                    <h2 className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                        aria-expanded="false"
                        aria-controls="collapseFour"
                      >
                        Are crypto currencies tax deductible?
                      </button>
                    </h2>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFour"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Ea commodi eius nisi fugiat eligendi neque repellendus
                        vero, aliquam temporibus, dicta optio eveniet saepe.
                        Beatae hic fugiat qui possimus doloribus? Ratione,
                        molestiae magnam.
                      </div>
                    </div>
                  </div>
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-duration="0.4s"
                    data-wow-delay="0.4s"
                  >
                    <h2 className="accordion-header" id="headingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                        aria-expanded="false"
                        aria-controls="collapseFive"
                      >
                        What is the benefit of monthly plan?
                      </button>
                    </h2>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingFive"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        Ea commodi eius nisi fugiat eligendi neque repellendus
                        vero, aliquam temporibus, dicta optio eveniet saepe.
                        Beatae hic fugiat qui possimus doloribus? Ratione,
                        molestiae magnam.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 d-none d-xl-block">
              <div
                className="fpic wow fadeInRight"
                data-wow-duration="0.4s"
                data-wow-delay="0.4s"
              >
                <img src="images/faq.png" alt="" className="faq-img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Faq;
